import { PlanCodes } from '../models/plan-codes';

export const hasAccessPlan = (planSku: string) => planSku === PlanCodes.Access;
export const hasConnectPlan = (planSku: string) =>
  planSku === PlanCodes.Connect || planSku === PlanCodes.ConnectPlus;
export const hasLegacyPlan = (planSku: string) => planSku === 'legacy';
export const hasDeprecatedPlan = (planSku: string) =>
  hasAccessPlan(planSku) || hasConnectPlan(planSku) || hasLegacyPlan(planSku);
export const hasSingleAccessPlan = (planSku: string) =>
  [
    PlanCodes.TerminalBiBerkSingleAccess,
    PlanCodes.TerminalHiscoxSingleAccess,
  ].includes(planSku as PlanCodes);
